<template>
    <div>
        <input type="hidden" name="agency_id" v-model="selectedAgency.id">
        <multiselect
            v-model="selectedAgency"
            track-by="id"
            label="name"
            :options="agencies"
            @input="$emit('selected', selectedAgency)">
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    components: {
        Multiselect,
    },

    props: {
        agencies: {
            type: Array,
            required: true
        },
        old: Object
    },

    data() {
        return {
            selectedAgency: {
                id: -1,
            },
        }
    },

    mounted() {
        this.loadAgencies()
    },

    methods: {
        async loadAgencies() {
            this.selectedAgency = this.$page.props.agency;

            if (this.old) {
                let oldAgencyId = parseInt(this.old.agency_id)
                for (let agency of this.agencies) {
                    if (agency.id === oldAgencyId) {
                        this.selectedAgency = agency;
                    }
                }
            }

            this.$emit('selected', this.selectedAgency);
        },
    },
}
</script>
